<template>
    <v-row class="row--x-small">
        <v-col cols="12" md="6" v-for="{ text, value, icon, items } in items" :key="value">
            <v-card flat v-bind="{ loading }">
                <v-select v-model="query[value]" v-bind="{ items }" multiple :placeholder="text" :prepend-inner-icon="icon" :key="value" hide-details outlined clearable @change="push">
                    <template #item="{ item }">
                        <v-list-item @click="setFilter({ key: value, value: item.value })">
                            <v-list-item-icon>
                                <v-simple-checkbox :value="query[value].includes(item.value)" color="primary" @click="setFilter({ key: value, value: item.value })" />
                            </v-list-item-icon>
                            <v-list-item-title> {{ item.text }} </v-list-item-title>
                        </v-list-item>
                    </template>
                </v-select>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { EMPLOYMENT_TYPES } from "@/assets/variables";

const initQuery = () => ({
    _categories: [],
    "employment.types": [],
    "employment.place.address1": [],
});

const regions = ["전국", "해외", "서울", "경기", "인천", "부산", "대구", "대전", "광주", "울산", "세종", "강원", "경남", "경북", "전남", "전북", "충남", "충북", "제주"].map((text) => ({ text, value: text }));

export default {
    data: () => ({
        loading: false,
        regions,
        categories: [],

        query: initQuery(),
    }),
    computed: {
        items() {
            return [
                {
                    text: "지역별",
                    value: "employment.place.address1",
                    icon: "icon icon-location",
                    items: this.regions,
                },
                {
                    text: "근무유형",
                    value: "employment.types",
                    icon: "icon icon-idcard",
                    items: Object.values(EMPLOYMENT_TYPES),
                },
            ];
        },
    },
    mounted() {
        this.init();
        this.sync();
    },
    methods: {
        async init() {
            this.loading = true;
            try {
            } finally {
                this.loading = false;
            }
        },
        async sync() {
            this.query = { ...initQuery(), ...this.$route.query };
        },

        async push() {
            let { ...query } = this.$route.query;

            delete query.page;

            if (this.query["_categories"]) {
                query["_categories"] = this.query["_categories"];
            } else delete query["_categories"];
            if (this.query["employment.types"]) {
                query["employment.types"] = this.query["employment.types"];
            } else delete query["employment.types"];
            if (this.query["employment.place.address1"]) {
                query["employment.place.address1"] = this.query["employment.place.address1"];
            } else delete query["employment.place.address1"];

            this.$router.push({ query });
        },

        setFilter({ key, value }) {
            if (this.query[key].includes(value)) {
                this.query[key] = this.query[key].filter((item) => item != value);
            } else {
                if (key == "employment.place.address1") {
                    switch (value) {
                        case "전국": {
                            this.query[key] = [value];
                            break;
                        }

                        default: {
                            this.query[key].push(value);
                            this.query[key] = this.query[key].filter((item) => item != "전국");
                            break;
                        }
                    }
                } else this.query[key].push(value);
            }
            this.push();
        },
    },
};
</script>

<style>
</style>